import AppButton from '../AppButton/AppButton'
import { X } from 'lucide-react'

interface Props {
    title: string
    description?: string
    onClose: () => void
    handleConfirm: () => void
    isOpen: boolean
}

const AppModal = ({
    title,
    description,
    isOpen,
    onClose,
    handleConfirm,
}: Props) => {
    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 z-10 overflow-y-auto ">
                    <div
                        className="fixed inset-0 w-full h-full bg-black opacity-40 rounded-lg"
                        onClick={onClose}
                    ></div>
                    <div className="flex items-center justify-center min-h-screen px-4 py-4 ">
                        <div className="relative w-full max-w-[504px] px-8 py-4 mx-auto bg-white rounded-lg shadow-lg">
                            <div className="flex items-center justify-between pb-4  border-gray-200">
                                <h4 className="text-lg font-bold text-gray-800">
                                    {title}
                                </h4>
                                <button
                                    onClick={onClose}
                                    className="text-gray-500 hover:text-gray-700 transition-colors"
                                    aria-label="Cerrar"
                                >
                                    <X size={24} />
                                </button>
                            </div>
                            <div className="border-b border-gray-200 w-[500px] ml-[-30px]"></div>

                            {description != null && description !== '' && (
                                <p className="mt-6 text-gray-700 text-base">
                                    {description}
                                </p>
                            )}

                            <div className="mt-8 flex justify-end gap-3">
                                <AppButton
                                    title="Cancelar"
                                    onClick={onClose}
                                    state="ghost"
                                    className="font-bold"
                                />
                                <AppButton
                                    title="Confirmar"
                                    onClick={handleConfirm}
                                    state="danger"
                                    className="font-bold"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default AppModal
